import firebase from 'firebase';
const firebaseApp = firebase.initializeApp({
    
  apiKey: "AIzaSyD0kRXycp3Fgcr6zTgd361hH5AbRliBZbY",
  authDomain: "whatsapp-clone-mirza.firebaseapp.com",
  databaseURL: "https://whatsapp-clone-mirza.firebaseio.com",
  projectId: "whatsapp-clone-mirza",
  storageBucket: "whatsapp-clone-mirza.appspot.com",
  messagingSenderId: "368308839030",
  appId: "1:368308839030:web:76d3ec8e141813c10c3557",
  measurementId: "G-EFPFSL0QP1"
    });
    
    
   
    const db = firebaseApp.firestore();
    
    const auth = firebase.auth();
    const provider = new firebase.auth.GoogleAuthProvider();
    
    export { auth, provider } ;
    export default db ;
  